import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ModalComponent } from '../../../../../lib/web/components/modal.component';
import { SessionService } from '../../../services/session.service';

@Component({
    selector: '.o-error-modal'
})
export class ErrorModalComponent extends ModalComponent<HTMLInputElement> {

    public constructor(node: HTMLInputElement, private _sessionService: SessionService) {
        super(node);
    }    

    public onInit(): void {
        super.onInit();
    }    

    public async open(error: any): Promise<any> {        
        this.setInnerHTML(this.getErrorContent(error), '.o-error-modal__content');
        const sessionId = this._sessionService.getSessionId();
        this.setInnerHTML(`${sessionId?.toUpperCase()} - ${new Date().getTime()}`, '.o-error-modal__session span');
        return super.open(error);
    }

    @ClickListener('.o-error-modal__close')
    public onClose(): void {
        this.close();
    }

    private getErrorContent(error: any): string {
        return Object.keys(error).map(k => {
            const value: any = error[k];
            if (typeof value == 'object') {
                return JSON.stringify(value);
            }
            else {
                return value;
            }
        }).join('</br>');
    }
}